import { cn } from '@/lib/utils';

interface BlobsProps {
  className?: string;
  /** Hide the amber blob for calmer sections. */
  soft?: boolean;
}

/** Ambient floating gradient blobs used behind hero and highlight sections. */
const Blobs = ({ className, soft = false }: BlobsProps) => (
  <div className={cn('blobfield', className)} aria-hidden="true">
    <span className="glow-blob b1" />
    <span className="glow-blob b2" />
    {!soft && <span className="glow-blob b3" />}
  </div>
);

export default Blobs;
